import React from 'react';

import { Icon as ChakraIcon } from '@chakra-ui/react';

import { IconProps } from '../../../icon';

export const SentimentWarningIcon = (props: IconProps) => (
  <ChakraIcon
    width="16"
    height="16"
    viewBox="-1 -1.2 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.00016 13.6667C10.6821 13.6667 13.6668 10.6819 13.6668 7.00004C13.6668 3.31814 10.6821 0.333374 7.00016 0.333374C3.31826 0.333374 0.333496 3.31814 0.333496 7.00004C0.333496 10.6819 3.31826 13.6667 7.00016 13.6667ZM7.00016 3.66671C6.63197 3.66671 6.3335 3.96518 6.3335 4.33337V8.33337C6.3335 8.70156 6.63197 9.00004 7.00016 9.00004C7.36835 9.00004 7.66683 8.70156 7.66683 8.33337V4.33337C7.66683 3.96518 7.36835 3.66671 7.00016 3.66671ZM7.00016 9.66671C6.63197 9.66671 6.3335 9.96519 6.3335 10.3334C6.3335 10.7016 6.63197 11 7.00016 11C7.36835 11 7.66683 10.7016 7.66683 10.3334C7.66683 9.96519 7.36835 9.66671 7.00016 9.66671Z"
      fill="#FF961A"
    />
  </ChakraIcon>
);
